import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./sections/Hero";
import About from "./sections/About";
import KnowledgeGap from "./sections/KnowledgeGap";
import DialogueSolution from "./sections/DialogueSolution";
import BookWheel from "./sections/BookWheel";
import Features from "./sections/Features";
import Pillars from "./sections/Pillars";
//import HowItWorks from "./sections/HowItWorks";
import JoinMovement from "./sections/JoinMovement";
import Footer from "./sections/Footer";
import FeaturedBooksSection from "./sections/FeaturedBooksSection";
import ScrollToTopButton from "./components/ScrollToTopButton";

export default function App() {
  return (
    <div className="w-full overflow-x-hidden">
      <Navbar />
      <Hero />
      <BookWheel />
      <KnowledgeGap />
      <DialogueSolution />
      <FeaturedBooksSection />
      <Features />
      <Pillars />
      {/* <HowItWorks /> */}
      <JoinMovement />
      <ScrollToTopButton />
      <About />
      <Footer />
    </div>
  );
}
